'use client';

import React, { createContext, useContext, type ReactNode } from 'react';
import { useNavigationScroll } from '@/hooks/use-navigation-scroll';

interface NavigationContextType {
  isNavigationVisible: boolean;
  navigationHeight: number;
}

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined
);

export function NavigationProvider({ children }: { children: ReactNode }) {
  const { isNavigationVisible } = useNavigationScroll();
  const navigationHeight = 64; // 4rem = 64px

  return (
    <NavigationContext.Provider
      value={{
        isNavigationVisible,
        navigationHeight,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}
